import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import { emptyFn } from '../../utils/helper';
import { decideKeepDom } from '../../utils/keepDom';
import { consumeTheme } from '../../utils/theme';
import { PreventScrollPenetrateContainer } from '../../utils/preventScrollPenetrate';
import { restoreFocus, saveFocus } from '../../utils/focus';
import { i18n } from '../../common/locale';
var DRAWER_LEAVING_TRANSITION_DURATION = 320;
var DRAWER_ENTERING_TRANSITION_DURATION = 400;
var Drawer = (function (_super) {
    __extends(Drawer, _super);
    function Drawer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.titleRef = React.createRef();
        _this.mainRef = React.createRef();
        _this.handleClose = function () {
            _this.props.onClose();
        };
        _this.handleMaskClick = function () {
            if (_this.props.mask && _this.props.maskClosable) {
                _this.handleClose();
            }
        };
        _this.themedRender = function (classNames) {
            var _a, _b, _c;
            var _d = _this.props, prefixCls = _d.prefixCls, className = _d.className, style = _d.style, children = _d.children, closable = _d.closable, mask = _d.mask, placement = _d.placement, title = _d.title, visible = _d.visible, headerStyle = _d.headerStyle, contentStyle = _d.contentStyle, destroyOnClose = _d.destroyOnClose, titleStyle = _d.titleStyle, closeStyle = _d.closeStyle, containerStyle = _d.containerStyle, zIndex = _d.zIndex, closeClassName = _d.closeClassName, containerClassName = _d.containerClassName, contentClassName = _d.contentClassName, headerClassName = _d.headerClassName, titleClassName = _d.titleClassName, embedded = _d.embedded;
            var containerCls = classNames(prefixCls + "-container", containerClassName, prefixCls + "-container-" + (visible ? 'visible' : 'hidden'), (_a = {},
                _a[prefixCls + "-container-embedded"] = embedded,
                _a));
            var cls = classNames(prefixCls, className, prefixCls + "-" + placement, prefixCls + "-" + (visible ? 'visible' : 'hidden'), (_b = {},
                _b[prefixCls + "-embedded"] = embedded,
                _b));
            var maskCls = classNames(prefixCls + "-mask", prefixCls + "-mask-" + (visible ? 'visible' : 'hidden'), (_c = {},
                _c[prefixCls + "-mask-display"] = mask,
                _c));
            if (destroyOnClose && !decideKeepDom.call(_this, DRAWER_LEAVING_TRANSITION_DURATION, visible)) {
                return null;
            }
            var content = (h(PreventScrollPenetrateContainer, { className: containerCls, style: __assign({ zIndex: zIndex }, containerStyle) },
                h("div", { className: maskCls, onClick: _this.handleMaskClick }),
                h("div", { className: cls, style: style, ref: _this.mainRef },
                    title || closable ?
                        h("div", { className: classNames(prefixCls + "-header", headerClassName), style: headerStyle },
                            h("span", { className: classNames(prefixCls + "-header-title", titleClassName), style: titleStyle, tabIndex: -1, ref: _this.titleRef }, title),
                            closable ?
                                h("button", { className: classNames(prefixCls + "-header-close", closeClassName), style: closeStyle, onClick: _this.handleClose, "aria-label": i18n('close') })
                                : null)
                        : null,
                    h("div", { className: classNames(prefixCls + "-content", contentClassName), style: contentStyle }, children))));
            if (embedded) {
                return content;
            }
            return ReactDOM.createPortal(content, document.body);
        };
        return _this;
    }
    Drawer.prototype.isFocusInside = function () {
        var _a;
        return (_a = this.mainRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement);
    };
    Drawer.prototype.focusSelf = function () {
        var _this = this;
        if (this.props.visible && !this.isFocusInside()) {
            saveFocus();
            setTimeout(function () {
                var _a;
                !_this.isFocusInside() && ((_a = _this.titleRef.current) === null || _a === void 0 ? void 0 : _a.focus());
            }, DRAWER_ENTERING_TRANSITION_DURATION);
        }
    };
    Drawer.prototype.restorePreviousFocus = function () {
        if (!this.props.visible) {
            restoreFocus();
        }
    };
    Drawer.prototype.componentDidMount = function () {
        this.focusSelf();
    };
    Drawer.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.visible) {
            this.focusSelf();
        }
        else {
            this.restorePreviousFocus();
        }
    };
    Drawer.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Drawer;
}(React.Component));
export default Drawer;
Drawer.defaultProps = {
    prefixCls: 'dui-drawer',
    closable: true,
    mask: false,
    maskClosable: true,
    onClose: emptyFn,
    placement: 'right',
    title: 'Drawer',
    destroyOnClose: false,
    embedded: false,
};
